import {createAction, props} from '@ngrx/store';
import {StockItem} from '../../../shared-utilities/models-old/datastructures';
import {IStore} from '../../../shared/shared-models/store/store';
import {IStockSearchAdvancedData} from './stock-search.models';
import {ISearchableFields} from '../../../shared/shared-models/type-sense/default-searchable-fields';

/**
 * Action to initiate a stock item search via TypeSense.
 */
export const searchStockItems = createAction(
  '[Stock Search] Search Stock Items',
  props<{query: string; store: IStore}>(),
);

/**
 * Action dispatched when stock item search succeeds.
 */
export const searchStockItemsSuccess = createAction(
  '[Stock Search] Search Stock Items Success',
  props<{items: StockItem[]}>(),
);

/**
 * Action dispatched when stock item search fails.
 */
export const searchStockItemsFailure = createAction(
  '[Stock Search] Search Stock Items Failure',
  props<{error: string}>(),
);

/**
 * Action to clear search results.
 */
export const clearStockSearch = createAction(
  '[Stock Search] Clear Stock Search',
);

/**
 * Action to initiate advanced stock search with full pagination support.
 */
export const searchStockItemsAdvanced = createAction(
  '[Stock Search] Search Stock Items Advanced',
  props<{query: string; store: IStore; filters?: Record<string, ISearchableFields>}>(),
);

/**
 * Action dispatched when advanced stock search succeeds.
 */
export const searchStockItemsAdvancedSuccess = createAction(
  '[Stock Search] Search Stock Items Advanced Success',
  props<{data: IStockSearchAdvancedData}>(),
);

/**
 * Action dispatched when advanced stock search fails.
 */
export const searchStockItemsAdvancedFailure = createAction(
  '[Stock Search] Search Stock Items Advanced Failure',
  props<{error: string}>(),
);

/**
 * Action to request a specific page of stock search results.
 */
export const getStockSearchPage = createAction(
  '[Stock Search] Get Stock Search Page',
  props<{pageNumber: number}>(),
);

/**
 * Action to update page size for stock search.
 */
export const setStockSearchPageSize = createAction(
  '[Stock Search] Set Stock Search Page Size',
  props<{pageSize: number}>(),
);
